module.exports = __webpack_public_path__ + "images/namallianz_small3d22a7f1f4f5dfe867865a467c758d3c.png";